/*
     Title: Constant for LIne
     Description: Constant for LIne
     Author: Iqbal Hossain
     Date: 06-January-2022
     Modified: 06-January-2022
*/

export const FETCH_LINE = 'FETCH_LINE';
export const TOGGLE_LINE_SIDEBAR = 'TOGGLE_LINE_SIDEBAR';
export const TOGGLE_LINE_STATUS = 'TOGGLE_LINE_STATUS';
export const FETCH_LINE_BY_QUERY = 'FETCH_LINE_BY_QUERY';
export const ADD_LINE = 'ADD_LINE';
export const DELETE_LINE = 'DELETE_LINE';
export const FETCH_LINE_BY_ID = 'FETCH_LINE_BY_ID';
export const UPDATE_LINE = 'UPDATE_LINE';
export const DELETE_LINE_BY_RANGE = 'DELETE_LINE_BY_RANGE';

/** Change Log
 * 08-Jan-2022(Iqbal): Add TOGGLE_LINE_SIDEBAR, FETCH_LINE_BY_QUERY, ADD_LINE, DELETE_LINE, FETCH_LINE_BY_ID, UPDATE_LINE, DELETE_LINE_BY_RANGE
 */
